// Dominios de Google Workspace de bee (D-26). La web NO decide quién entra —eso lo
// hacen las funciones de bloqueo (que ven el claim hd), la API y las reglas—; aquí
// solo se arma la pantalla de Google y se le dice a la persona qué cuenta usar. La
// lista es la misma que en api/src/lib/dominios.ts y functions/dominios.js.

export const DOMINIOS_BEE: readonly string[] = ['beemexico.com', 'gelimer.mx']

const conArroba = DOMINIOS_BEE.map((d) => `@${d}`)

/** "@beemexico.com o @gelimer.mx" */
export const TEXTO_DOMINIOS =
  conArroba.length <= 1
    ? (conArroba[0] ?? '')
    : `${conArroba.slice(0, -1).join(', ')} o ${conArroba[conArroba.length - 1]}`

export const SOLO_CUENTAS_BEE = `Solo cuentas de bee (${TEXTO_DOMINIOS})`

export const USA_CUENTA_BEE = `No se pudo iniciar sesión. Usa tu cuenta de bee (${TEXTO_DOMINIOS}).`

/**
 * Parámetros de la pantalla de Google. Con un solo dominio iba hd=beemexico.com; con
 * dos, Google no acepta una lista, así que va hd=* = "solo cuentas de Workspace" (de
 * cualquier dominio). Es pista de UX, no seguridad: las funciones de bloqueo exigen
 * que el hd sea uno de los nuestros y que el correo sea de ese mismo dominio.
 */
export const PARAMETROS_GOOGLE = { hd: '*', prompt: 'select_account' } as const
